export const GET_LOCATION_SELLER = 'get-location-seller';
const getLocationSeller = ({ locationId }) => ({
  type: GET_LOCATION_SELLER,
  payload: {
    locationId,
  },
});
export default getLocationSeller;
